import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  items: [],
  isDownloading: false,
  errorDownloading: false,
  isUploading: false,
  errorUploading: false,
  isUploaded: false,

  isUploadingDoc: false,
  errorUploadingDoc: false,
  isUploadedDoc: false,

  getDoc: {},
  errorGetDoc: false,
  isLoadingGetDoc: false,

  verifyDoc: {},
  errorVerifyDoc: false,
  isLoadingVerifyDoc: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/file/index.js